/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ImplementDataDto } from './implementDataDto';
import { EmployeeDataDto } from './employeeDataDto';
import { MachineDataDto } from './machineDataDto';

export interface ArrivalDataDto {
  employeeDataArrival?: Array<EmployeeDataDto>;
  employeeDataPreparation?: Array<EmployeeDataDto>;
  implementDataArrival?: Array<ImplementDataDto>;
  implementDataPreparation?: Array<ImplementDataDto>;
  machineDataArrival?: Array<MachineDataDto>;
  machineDataPreparation?: Array<MachineDataDto>;
}
